import PageTitle from 'common/components/PageTitle'
import React from 'react'
import { Button, Form, Input, message } from 'antd'
import * as Styled from './styled'
import history from 'utils/history'
import { ADMIN_ROUTER_PATH } from 'common/config'
import { requestChangeDepositPass } from 'services/api/CommonApi'
import { useTranslation } from 'react-i18next'

const DepositPassPage: React.FC = () => {
  const { t } = useTranslation()
  const onFinish = async (values: any) => {
    const resData = await requestChangeDepositPass({
      old_tfa_password: values.old,
      new_tfa_password: values.new,
    })

    if (resData.status) {
      message.success(t('change_pass_correct'))
      history.push(ADMIN_ROUTER_PATH.PROFILE)
    } else {
      message.error(t('pass_not_correct'))
    }
  }

  return (
    <div>
      <Styled.WrapCardCenter>
        <PageTitle title={t('change_capital_password')} />
        <Styled.CardForm>
          <span>{t('capital_password')}</span>
          <Form layout={'vertical'} onFinish={onFinish}>
            <Form.Item
              name={'old'}
              rules={[{ required: true, message: t('not_empty') }]}
              label={t('password_present')}
            >
              <Input
                type={'password'}
                placeholder={t('input_password_present')}
              />
            </Form.Item>
            <Form.Item
              name={'new'}
              rules={[{ required: true, message: t('not_empty') }]}
              label={t('new_password')}
            >
              <Input type={'password'} placeholder={t('input_new_password')} />
            </Form.Item>
            <Form.Item
              name={'verify'}
              rules={[
                { required: true, message: t('not_empty') },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue('new') === value) {
                      return Promise.resolve()
                    }
                    return Promise.reject(new Error(t('pass_incorrect')))
                  },
                }),
              ]}
              label={t('confirm_password')}
            >
              <Input type={'password'} placeholder={t('input_new_password')} />
            </Form.Item>
            <div style={{ marginTop: 10 }} className="warning-text">
              {t('note_change_password')}{' '}
              <b
                onClick={() => history.push(ADMIN_ROUTER_PATH.SUPPORT)}
                style={{ color: '#1890ff', cursor: 'pointer' }}
              >
                {t('contact_support')}
              </b>
            </div>
            <Form.Item
              style={{
                marginBottom: 0,
                marginTop: 15,
              }}
            >
              <Button
                type="primary"
                htmlType="submit"
                style={{
                  width: '100%',
                  height: 40,
                  fontWeight: 700,
                }}
              >
                {t('change_pass')}
              </Button>
            </Form.Item>
          </Form>
        </Styled.CardForm>
      </Styled.WrapCardCenter>
    </div>
  )
}
export default DepositPassPage
